/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversion_Status_DeletedInputs */

const en_conversion_status_deleted = /** @type {(inputs: Conversion_Status_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleted`)
};

const es_conversion_status_deleted = /** @type {(inputs: Conversion_Status_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminado`)
};

/**
* | output |
* | --- |
* | "Deleted" |
*
* @param {Conversion_Status_DeletedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const conversion_status_deleted = /** @type {((inputs?: Conversion_Status_DeletedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversion_Status_DeletedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_conversion_status_deleted(inputs)
	return en_conversion_status_deleted(inputs)
});